import * as React from 'react'
import usePostStore from 'Store/postStore'
import useLightBoxStore from 'Store/lightBoxStore'
import Loader from 'Components/Loader'
import Container from '@mui/material/Container'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import ImageList from 'Components/ImageList'
import Like from 'Widgets/Like'
import { useTranslation } from 'react-i18next'
import InfiniteScroll from 'react-infinite-scroll-component'

import Button from '@mui/material/Button'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined'
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined'
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined'
import Moment from 'Components/Moment/Moment'

interface Props {}
const Posts: React.FC<Props> = React.memo(function Posts() {
      const { t } = useTranslation()

      const loading = usePostStore((state) => state.loading)
      const posts = usePostStore((state) => state.posts)
      const init = usePostStore((state) => state.init)
      const getPosts = usePostStore((state) => state.getPosts)
      const pagination = usePostStore((state) => state.pagination)

      const openLightBox = useLightBoxStore((state) => state.openLightBox)

      // const medias = []
      const images = []
      // posts.map((post) => {
      //   if (post.media.length > 0) {
      //     post.media.forEach((m, idx) => {
      //       images.push(m)
      //       medias.push({
      //         id: m.id,
      //         src: m.urls.full,
      //         srcSet: m.srcset,
      //         title: post.title,
      //         author: post.creator,
      //         featured: idx < 1 || m.likes.count,
      //         fullWidth: post.media.length < 2,
      //         bottomRightButton: <Like id={m.id} likes={m.likes} />,
      //       })
      //     })
      //   }
      // })

      const handleOnItemSelect = (id: number) => {
            // const idx = medias.findIndex((m) => m.id === id)
            // if (idx >= 0) {
            //   openLightBox({images: images, photoIndex: idx })
            // }
      }
      const fetchData = async () => {
            await init()
            await getPosts()
      }

      React.useEffect(() => {
            fetchData()
      }, [])

      return (
            <InfiniteScroll
                  dataLength={posts.length}
                  next={getPosts}
                  hasMore={
                        pagination &&
                        pagination.meta &&
                        pagination.meta.current_page < pagination.meta.total_pages
                  }
                  loader={<Loader />}
                  endMessage={<p className="text-center"></p>}
            >
                  {/* <Stack direction="row" sx={{ justifyContent: 'space-between' }}> */}
                  {/* <Typography variant="body2">{t('contents')}</Typography> */}
                  {/* <Typography variant="body2">{medias.length} {t('items')}</Typography> */}
                  {/* </Stack> */}
                  {posts.map((post) => {
                        const medias = []
                        if (post.media.length > 0) {
                              post.media.forEach((m, idx) => {
                                    images.push({ ...m, author: post.creator.name })
                                    medias.push({
                                          id: m.id,
                                          src: m.urls.full,
                                          srcSet: m.srcset,
                                          title: post.title,
                                          author: post.creator,
                                          featured: idx < 1 || m.likes.count,
                                          fullWidth: post.media.length < 2,
                                          isVideo: m.mime?.startsWith('video/'),
                                          bottomRightButton: <Like id={m.id} likes={m.likes} />,
                                    })
                              })
                        }
                        const handleOnItemSelect = (id: number) => {
                              const idx = images.findIndex((m) => m.id === id)
                              if (idx >= 0) {
                                    openLightBox({ images: images, photoIndex: idx })
                              }
                        }
                        return (
                              <>
                                    <Stack spacing={1} sx={{ padding: '10px 0' }} direction={'row'}>
                                          <Button
                                                variant="contained"
                                                sx={{ boxShadow: 'none' }}
                                                color="primary"
                                                startIcon={<CalendarTodayIcon />}
                                          >
                                                <Typography
                                                      variant="body2"
                                                      sx={{
                                                            textOverflow: 'ellipsis',
                                                            whiteSpace: 'nowrap',
                                                      }}
                                                >
                                                      <Moment format="datetime" date={post.date} />
                                                </Typography>
                                          </Button>
                                          {/* <Button 
                  variant='contained' 
                  sx={{boxShadow: 'none'}}
                  color='primary' startIcon={<AccessTimeOutlinedIcon/>}>
                    <Typography variant='body2' sx={{textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                      <Moment format='time' date={post.date}/>
                    </Typography>
                </Button> */}
                                          {/* <Button 
                  variant='contained' 
                  sx={{boxShadow: 'none'}}
                  color='primary' startIcon={<LocationOnOutlinedIcon/>}>
                  <Typography variant='body2' sx={{textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap'}}>
                    aaaa
                  </Typography>
                </Button> */}
                                          <Button
                                                variant="contained"
                                                sx={{ boxShadow: 'none' }}
                                                color="primary"
                                                startIcon={<PersonOutlinedIcon />}
                                          >
                                                <Typography
                                                      variant="body2"
                                                      sx={{
                                                            textOverflow: 'ellipsis',
                                                            overflow: 'hidden',
                                                            whiteSpace: 'nowrap',
                                                      }}
                                                >
                                                      {post.creator.name}
                                                </Typography>
                                          </Button>
                                    </Stack>
                                    <ImageList items={medias} onItemSelect={handleOnItemSelect} />
                              </>
                        )
                  })}
            </InfiniteScroll>
      )
})

export default Posts
